import { Locale } from '__generated__/graphql';
import { isSupportedLocale } from '../../i18n';
import { isValidLocale } from '../../common/helpers';
import useUrlState from '../../common/useUrlState';

export interface CheckoutUrlState {
  locale?: Locale | null,
  orderId?: string;
  orderToken?: string;
  paymentStatus?: string;
  showCategories?: string[];
  ticketCategoryIds?: string[];
  coupon?: string;
  invitationCode?: string;
  charityId?: string;
  sourceUrl?: string;
  initialUrl?: string;
  finalUrl?: string;
  flags?: string; // Feature flags.
}

const useCheckoutUrlState = () => useUrlState<CheckoutUrlState>({
  parse: (params, { string, array }) => ({
    ...params,
    locale: isValidLocale(params.locale) && isSupportedLocale(params.locale) ? params.locale : null,
    orderId: string(params.orderId),
    orderToken: string(params.orderToken),
    paymentStatus: string(params.paymentStatus),
    showCategories: array(params.showCategories, string),
    ticketCategoryIds: array(params.ticketCategoryIds || (
      string(params.ticketCategoryId, null) ? [params.ticketCategoryId] : null
    ), string),
    coupon: string(params.coupon),
    invitationCode: string(params.invitationCode),
    charityId: string(params.charityId),
    sourceUrl: string(params.sourceUrl),
    initialUrl: string(params.initialUrl),
    finalUrl: string(params.finalUrl),
    flags: string(params.flags), // Feature flags
  }),
});

export default useCheckoutUrlState;
